import React from 'react';
import './FloorTitle.less';
import autobind from 'autobind-decorator';

interface FloorTitleState {

}

interface FloorTitlePropType {
    prefixCls?: string;
    floorName?: string;
    imgUrl?: string;
    showline?: string;
}

class FloorTitle extends React.Component<FloorTitlePropType, FloorTitleState> {
    static defaultProps = {
        prefixCls: 'floorTitle',
    };

    @autobind
    showLineColor(isShowBg: any) {
        const {prefixCls} = this.props;
        return isShowBg ? `` : `${prefixCls}-showLineColor`;
    }

    render() {
        const {prefixCls, floorName, imgUrl} = this.props;

        const style = {
            backgroundImage: 'url(' + imgUrl + ')',
            backgroundSize: '100% 100%',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'left top'
        };
        // style={showline && !imgUrl ? {borderBottom: ' .1rem solid rgba(155,155,155,0.2)'} : {}}
        return (
            <div className={prefixCls} style={style}>
                <div className={`${prefixCls}-title`}>
                    <div className={`${prefixCls}-titleCenter`}>
                        {/*<span className={this.showLineColor(!imgUrl)}/>*/}
                        <p>{!imgUrl && floorName}</p>
                        {/*<span className={this.showLineColor(!imgUrl)}/>*/}
                    </div>
                </div>
            </div>
        );
    }
}

export default FloorTitle;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/widgets/floorModule/floorTitle/FloorTitle.tsx